module.exports = __webpack_public_path__ + "img/car-clr-2.72e9cf05.png";